import { auth } from "./firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { store } from "../redux/store";
import { setUser, clearUser } from "../redux/authSlice";
import { saveUserToDynamoDB, getUserFromDynamoDB } from "../api/apiService";

const handleUserSignup = async (user) => {
  if (!user) return;

  try {
    await saveUserToDynamoDB(user);
    console.log("User data uploaded to DynamoDB successfully!");
  } catch (error) {
    console.error("Error saving user to DynamoDB:", error);
  }
};

const getUserDetails = () => {
  if (!auth) {
    console.error('[Auth] Firebase auth is not initialized. Restore your .env file.');
    store.dispatch(clearUser());
    return;
  }

  onAuthStateChanged(auth, async (user) => {
    if (user) {
      try {
        const userData = await getUserFromDynamoDB(user.email);

        if (userData) {
          store.dispatch(setUser({ 
            uid: user.uid,
            email: user.email,
            role: userData.role,
            projectId: userData.projectId,
            site: userData.site,
          }));
        } else {
          console.warn('User document not found in DynamoDB');
          // If user exists in Firebase Auth but not in DynamoDB, create the record
          await handleUserSignup(user);
        }
      } catch (error) {
        console.error('Error fetching user details from DynamoDB:', error);
      }
    } else {
      console.log("No user is logged in");
      store.dispatch(clearUser());
    }
  });
};

export default getUserDetails;
